import React from 'react';
import { IOrder } from '@/interfaces/order';
import TemplateHeader from './components/template-header';
import DeliveryQrcode from './components/template-qr-driver';
import { useSetting } from '@/contexts/CompanyContext';

interface IProps {
  data: IOrder;
}

const TM26 = ({ data }: IProps) => {
  const { setting } = useSetting();
  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateHeader
        description="ใช้สำหรับคนขับรถ"
        titleEn="Delivery Order"
        titleTh={data?.code}
        businessUnitLogo={data.businessUnitLogo}
      />
      {(data?.driverToken != '00000000-0000-0000-0000-000000000000' && (
        <DeliveryQrcode
          link={`${setting?.driverLink}/${data?.driverToken}`}
          code={data.code}
        />
      )) ||
        ''}
    </div>
  );
};

export default TM26;
